var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.userInfo.staff)?_c('ScheduleReadOnly'):_c('JobSchedule')}
var staticRenderFns = []

export { render, staticRenderFns }